(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ht-catalog-category"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initGallery(m) {
    if (m.hasAttribute('data-gallery-ready')) return;
    var slides = m.querySelector('.ht-card__slides');
    if (!slides) return;
    var count = slides.children.length;
    m.setAttribute('data-gallery-ready', '1');
    if (count < 2) return;
    var card = m.closest('.ht-card');
    var dots = card ? card.querySelector('.ht-card__dots') : null;
    var i = 0;
    function go(n) {
      i = (n + count) % count;
      slides.style.transform = 'translateX(-' + (i * 100) + '%)';
      if (dots) {
        Array.prototype.forEach.call(dots.children, function (d, idx) {
          d.classList.toggle('is-active', idx === i);
        });
      }
    }
    var prev = m.querySelector('.ht-card__nav--prev');
    var next = m.querySelector('.ht-card__nav--next');
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); go(i - 1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); go(i + 1); });
    if (dots) {
      Array.prototype.forEach.call(dots.children, function (d, idx) {
        d.addEventListener('click', function () { go(idx); });
      });
    }
    go(0);
  }
  function initAll(root) {
    (root || document).querySelectorAll('.ht-card__media[data-gallery]').forEach(initGallery);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
